import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

/** True on the /demo preview routes, which mirror the tenant site under a prefix. */
export function useIsDemoRoute() {
  const { pathname } = useLocation();
  return pathname === '/demo' || pathname.startsWith('/demo/');
}

/** Maps a tenant path ("/booking") to the right URL for the current site (demo or live). */
export function useTenantPath() {
  const isDemo = useIsDemoRoute();
  return useCallback(
    (path: string) => {
      if (!isDemo) return path;
      if (path === '/') return '/demo';
      if (['/services', '/about', '/booking', '/contact'].includes(path)) return `/demo${path}`;
      return path;
    },
    [isDemo],
  );
}
